module.exports = __webpack_public_path__ + "static/media/standardLanding.db8858c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footers/standardLanding.png
// module id = 1238
// module chunks = 0